import styled, { css } from 'styled-components';

import { Button, defaultThemeProp, Text } from '@pega/cosmos-react-core';

export const StyledCodeBlock = styled.pre`
  padding: ${props => props.theme.base.spacing};
  margin-bottom: ${props => props.theme.base.spacing};
`;

StyledCodeBlock.defaultProps = defaultThemeProp;

export const StyledPromotedFilters = styled.div<{
  isVertical: boolean;
}>(props => {
  const { theme, isVertical } = props;

  return css`
    border-radius: ${theme.components.card['border-radius']};
    background-color: ${theme.base.palette['secondary-background']};
    ${isVertical &&
    css`
      max-width: 20rem;
    `}
  `;
});

StyledPromotedFilters.defaultProps = defaultThemeProp;

export const StyledClearAllButton = styled(Button)`
  margin-top: 0.625rem;
  white-space: nowrap;
`;

StyledClearAllButton.defaultProps = defaultThemeProp;

export const StyledVerticalWrapper = styled.div`
  width: 100%;
`;

StyledVerticalWrapper.defaultProps = defaultThemeProp;

export const StyledTextWithEllipsis = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

StyledTextWithEllipsis.defaultProps = defaultThemeProp;
